module.exports = __webpack_public_path__ + "static/media/medium-van.04e40f36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vehicles/medium-van.png
// module id = 663
// module chunks = 27